import { createFileRoute } from '@tanstack/react-router';

import {
  settlementSummaryQueryOptions,
  statementsQueryOptions,
  withdrawalsQueryOptions,
} from '@/features/settlements/api';
import { SettlementsPage } from '@/features/settlements/components/settlements-page';
import { settlementsSearchSchema } from '@/features/settlements/search';

export const Route = createFileRoute('/_app/settlements/')({
  validateSearch: settlementsSearchSchema,
  loaderDeps: ({ search }) => search,
  staticData: { title: '정산 내역', group: '정산' },
  loader: ({ context: { queryClient }, deps }) => {
    const tabQuery =
      deps.tab === 'statements'
        ? queryClient.query(statementsQueryOptions())
        : queryClient.query(withdrawalsQueryOptions(deps.page));
    void tabQuery.catch(() => undefined);
    return queryClient.query({ ...settlementSummaryQueryOptions(), staleTime: 'static' });
  },
  head: () => ({ meta: [{ title: '정산 내역 · 팬즈드롭 파트너' }] }),
  component: SettlementsRoute,
});

function SettlementsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <SettlementsPage
      search={search}
      onSearchChange={next => {
        void navigate({
          search: previous => ({ ...previous, ...next }),
          replace: true,
          resetScroll: false,
        });
      }}
    />
  );
}
